import { useQuery } from "@tanstack/react-query";
import useApiCountry from "./useApiCountry";

const useListCountries = () => {
    const { listCountries } = useApiCountry();

    return useQuery({
        queryKey: ["countries"],
        queryFn: () => listCountries(),
        staleTime: 1000 * 60 * 60 * 24,
        placeholderData: (previousData) => previousData,
    });
}

export default useListCountries;